import React from "react";
import { Switch, Route } from "react-router-dom";
import { Header, Footer, Home, Skills, Works, Contacts } from "./";
import { PageWrapper } from "../styles";
import {
  HOME_ROUTE,
  SKILLS_ROUTE,
  WORKS_ROUTE,
  CONTACTS_ROUTE,
} from "../utils/constants";

export const AppRouter = () => {
  return (
    <PageWrapper>
      <Header />
      <Switch>
        <Route exact path={HOME_ROUTE} component={Home} />
        <Route exact path={SKILLS_ROUTE} component={Skills} />
        <Route exact path={WORKS_ROUTE} component={Works} />
        <Route exact path={CONTACTS_ROUTE} component={Contacts} />
      </Switch>
      <Footer />
    </PageWrapper>
  );
};
